import {AuditActionTypes, AuditEntityTypes} from './constants';
import $ from "jquery";
import DropdownTemplateView from './../../DropdownTemplateView';
import {
    ArchiveStatusAuditRecord,
    DeadlineAuditRecord,
    DescriptionAuditRecord, EstimateAuditRecord, MoveProjectToAuditRecord, MoveTaskToAuditRecord, RenamedAuditRecord, StatusAuditRecord, WorkflowStatusAuditRecord,
    TypeOfWorkAuditRecord
} from "./UpdateAuditRecord";
import SimpleViewTooltip from "../../SimpleViewTooltip";
import TemplateView from "../../TemplateView";
import ScrollUtils from '../../util/ScrollUtils'
import {isIE8} from '../../atBrowserUtils'

const MAX_SCROLL_HEIGHT= 300;

export class AuditHistoryScrollView extends TemplateView {

    constructor($containerEl)
    {
        super($containerEl);

        this.state = {
            allAuditHistoryLoaded: false,
        }
    }

    templateHtml()
    {
        return "<div class='scrollView scrollableContainer'>" +
               "  <div class='innerContainer'>" +
               "    <div class='placeholder top'></div>" +
               "    <div class='itemsContainer'></div>" +
               "    <div class='placeholder bottom'></div>" +
               "  </div>" +
               "</div>";
    }

    afterRender()
    {
        this.items = [];
        this.$topPlaceholder = this.find(".placeholder.top");
        this.$bottomPlaceholder = this.find(".placeholder.bottom");
        this.$itemsContainer = this.find(".itemsContainer");

        this.verticalScroll = ScrollUtils.addVerticalScroll(this.$el, {probeType: 2});
        if (!isIE8())
        {
            this.verticalScroll.on("scroll", () => this.onScroll());
        }
    }

    addItems(items)
    {
        this.items = this.items.concat(items);
        for (let item of items)
        {
            item.init(this.$itemsContainer);
        }
        this.refreshScroll();
    }

    setItems(items)
    {
        this.items = [];
        this.$itemsContainer.empty();
        this.addItems(items);
    }

    refreshScroll()
    {
        const height = this.$itemsContainer.height();
        this.$el.height(height < MAX_SCROLL_HEIGHT ? height : MAX_SCROLL_HEIGHT);
        ScrollUtils.refreshCustomScroll(this.verticalScroll);
        this._checkIfScrolledToEnd();
    }

    _checkIfScrolledToEnd()
    {
        if (!this._suppressScrollCheck && !this.state.allAuditHistoryLoaded) {
            ScrollUtils.performIfScrollToBottom(this.verticalScroll, 100, () => {
                this.trigger("scrollToEnd");
            })
        }
    }

    onScroll()
    {
        this._checkIfScrolledToEnd();
    }

    suppressScrollCheck(suppress)
    {
        this._suppressScrollCheck = suppress;
    }
}

export default class AuditHistoryMenu extends DropdownTemplateView {

    templateHtml()
    {
        return "<div class='auditHistoryMenu dropdownContainer'/>";
    }

    constructor($containerEl, extraClass, onContentClickCb = () => {})
    {
        super($containerEl, extraClass);
        this.items = [];
        this.extraClass = extraClass;

        this.state = {
            allAuditHistoryLoaded: false,
        }

        this.callbacks = {
            onContentClickCb,
        }

        this.onStatePropertyChanged('allAuditHistoryLoaded', allAuditHistoryLoaded => {
            this.scrollView.setState({allAuditHistoryLoaded})
        })
    }

    setDateFormat(dateFormat)
    {
        this.dateFormat = dateFormat;
    }

    afterRender()
    {
        if (this.extraClass)
            this.$el.addClass(this.extraClass);
        this.scrollView = new AuditHistoryScrollView(this.$el).init();
        this.scrollView.suppressScrollCheck(true);
        this.tooltip = new SimpleViewTooltip($("body"), 'auditRecordTooltip ' + this.extraClass + 'Tooltip').init();

        this.$el.click(e => this.callbacks.onContentClickCb(e))
    }

    addItems(auditRecords)
    {
        this.items = this.items.concat(auditRecords);
        this.scrollView.setItems(this.items.map((record) =>  this.getAuditRecord(record)));
    }

    getItems()
    {
        return this.items
    }

    setItems(auditRecords)
    {
        this.items = auditRecords;
        this.scrollView.setItems(auditRecords.map((record) => this.getAuditRecord(record)));
    }

    onShow()
    {
        super.onShow();
        this.scrollView.refreshScroll();
        this.scrollView.suppressScrollCheck(false);
    }

    onHide()
    {
        super.onHide();
        this.scrollView.suppressScrollCheck(true);
    }

    getAuditRecord(record)
    {
        switch (record.type)
        {
            case AuditActionTypes.RENAMED:
                return new RenamedAuditRecord(record, this.dateFormat, this.tooltip);
                break;
            case AuditActionTypes.REOPENED:
            case AuditActionTypes.COMPLETED:
                return new StatusAuditRecord(record, this.dateFormat);
                break;
            case AuditActionTypes.ARCHIVED:
            case AuditActionTypes.RESTORED:
                return new ArchiveStatusAuditRecord(record, this.dateFormat);
                break;
            case AuditActionTypes.BILLING_TYPE_CHANGED:
                return new TypeOfWorkAuditRecord(record, this.dateFormat, this.tooltip);
                break;
            case AuditActionTypes.DEADLINE_CHANGED:
                return new DeadlineAuditRecord(record, this.dateFormat);
                break;
            case AuditActionTypes.ESTIMATE_CHANGED:
                return new EstimateAuditRecord(record, this.dateFormat);
                break;
            case AuditActionTypes.DESCRIPTION_CHANGED:
                return new DescriptionAuditRecord(record, this.dateFormat, this.tooltip);
                break;
            case AuditActionTypes.MOVED:
                return record.object['type'] === AuditEntityTypes['TASK'] ? new MoveTaskToAuditRecord(record, this.dateFormat, this.tooltip) :
                        new MoveProjectToAuditRecord(record, this.dateFormat, this.tooltip);
                break;
            case AuditActionTypes.WORKFLOW_STATUS_AND_TYPE_CHANGED:
            case AuditActionTypes.WORKFLOW_STATUS_ONLY_CHANGED:
                return new WorkflowStatusAuditRecord(record, this.dateFormat);
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/auditHsitory/AuditHistoryMenu.js